import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { LangSwitcher } from "./LangSwitcher";
import { Container } from "./Shared";
import { useLang } from "../lib/lang";

export const WA = "https://wa.me/491608493791";
export const PHONE = "+49 160 8493791";

const Col = ({ title, children }) => (
  <div>
    <p className="eyebrow mb-5 text-[#9FD3CD]">{title}</p>
    <ul className="space-y-3 text-[0.95rem] text-white/80">{children}</ul>
  </div>
);
const L = ({ to, children, id }) => <li><Link to={to} className="transition-colors hover:text-white" data-testid={id}>{children}</Link></li>;

export const Footer = () => {
  const { t, r } = useLang();
  return (
    <footer className="relative overflow-hidden bg-[var(--ink)] text-white grain" data-testid="site-footer">
      <Container className="relative pb-10 pt-20 md:pt-28">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-6 max-w-sm text-white/75">{t.footer.tagline}</p>
            <div className="mt-8"><p className="eyebrow mb-3 text-[#9FD3CD]">{t.footer.language}</p><LangSwitcher light className="inline-flex" /></div>
          </div>
          <div className="grid gap-10 sm:grid-cols-3 lg:col-span-8">
            <Col title={t.footer.services}>
              {["translation", "certified", "interpreting", "consecutive", "online", "events", "writing", "other"].map((k) => <L key={k} to={r(k)} id={`footer-${k}`}>{t.nav[k]}</L>)}
            </Col>
            <Col title={t.footer.company}>
              <L to={r("about")} id="footer-about">{t.nav.about}</L>
              <L to={r("blog")} id="footer-blog">{t.nav.blog}</L>
              <L to={r("testimonials")} id="footer-testimonials">{t.footer.testimonials}</L>
              <L to={r("contact")} id="footer-contact">{t.nav.contact}</L>
              <L to={r("upload")} id="footer-upload">{t.upcta.cta}</L>
            </Col>
            <Col title={t.nav.contact}>
              <li><a href="mailto:info@translinked.net" className="flex items-center gap-2 hover:text-white" data-testid="footer-email"><Mail className="h-4 w-4 text-[var(--teal)]" />info@translinked.net</a></li>
              <li><a href="tel:+491608493791" className="flex items-center gap-2 hover:text-white" data-testid="footer-phone"><Phone className="h-4 w-4 text-[var(--teal)]" />{PHONE}</a></li>
              <li><a href={WA} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-[var(--teal)]" />WhatsApp</a></li>
              <li className="flex gap-2"><MapPin className="mt-1 h-4 w-4 shrink-0 text-[var(--teal)]" /><span>Aegidiistr. 35<br />48143 Münster</span></li>
            </Col>
          </div>
        </div>
        <div className="mt-20 select-none font-display text-[18vw] font-light leading-[0.8] tracking-[-0.05em] text-white/[0.06] lg:text-[13rem]" aria-hidden="true">translinked</div>
        <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-white/70 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Translinked · Gema García Crespo. {t.footer.rights}</p>
          <div className="flex flex-wrap gap-6">
            <Link to={r("legal")} className="hover:text-white" data-testid="footer-imprint">{t.footer.imprint}</Link>
            <Link to={r("privacy")} className="hover:text-white" data-testid="footer-privacy">{t.footer.privacy}</Link>
            <Link to="/admin" className="hover:text-white" rel="nofollow" data-testid="footer-admin">{t.footer.admin}</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
};
